import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import cookies from 'js-cookie';
import App from './App';
import AppLoading from './components/layouts/AppLoading';

i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.use(LanguageDetector)
	.use(HttpApi)
	.init({
		supportedLngs: ['en', 'fr', 'rw'],
		fallbackLng: 'en',
		detection: {
			order: ['querystring', 'cookie', 'htmlTag', 'localStorage', 'path', 'subdomain'],
			caches: ['cookie'],
		},
		backend: {
			loadPath: '/assets/locales/{{lng}}/translation.json',
		},
	});

	
if(!cookies.get('i18next')){
	i18n.changeLanguage("rw")
}

// When language is passed through the query string
const lang = new URLSearchParams(location.search).get('lang');
if(lang){
  i18n.changeLanguage(lang)
}


const loadingMarkup = <AppLoading />;

ReactDOM.render(
	<Suspense fallback={loadingMarkup}>
		<App />
	</Suspense>,
	document.getElementById('root')
);
